// extracted by mini-css-extract-plugin
module.exports = {"custom":"_266273ad71e4f7e4f7053b4bd21f4568-less"};